var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcoArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 9,
    viewBox: "0 0 17 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 0.83066C17.0006 0.939913 16.979 1.04822 16.9363 1.14936C16.8937 1.25051 16.8308 1.34246 16.7513 1.42003L9.1026 8.75851C8.94194 8.91313 8.72465 9 8.49811 9C8.27158 9 8.05423 8.91313 7.89358 8.75851L0.253417 1.42003C0.0919511 1.26481 0.000809052 1.05389 5.00515e-06 0.8336C-0.000799042 0.613308 0.0888489 0.401662 0.249178 0.245342C0.409507 0.0890218 0.627375 0.000784669 0.854918 6.24013e-06C1.08246 -0.000772189 1.30102 0.0859678 1.46249 0.241187L8.5024 6.9986L15.5423 0.241186C15.6626 0.126952 15.8152 0.0496566 15.9807 0.0188542C16.1462 -0.0119483 16.3174 0.0051114 16.473 0.0680023C16.6285 0.130893 16.7614 0.236785 16.8552 0.372417C16.9489 0.508049 16.9993 0.667472 17 0.83066V0.83066Z",
    fill: "#2C2C2C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoArrow);
export default __webpack_public_path__ + "static/media/ico_arrow.a215c4430f58fac11caa43195386ef26.svg";
export { ForwardRef as ReactComponent };